export const BASE_LINK = "/"; // 首页
export const ROOM_ARRANGE_LINK = "/room/arrangement"; // 某个房间的排期
export const ROOM_FORM_LINK = "/roomForm/submit"; //提交form表单
export const ROOM_DETAIL_LINK = "/roomDetail/roomId";
export const MY_RESERVE_LINK = "/myReserve/list";
export const MY_RESERVE_DETAIL_LINK = "/myReserve/detail";
export const RESERVE_RESULT_LINK = "/reserve/result";
export const ROOM_SEARCH_LINK = "/room/search";
export const LOGIN_LINK = "/login";
export const CHANGEPASSWORD = "/ChangePassword";

export const FIND_PAGE_ARRANGEMENT_URL = "/lab/rest/reservations/findPageArrangementByDate";
export const ROOM_LIST_URL = "/lab/rest/room/list";
export const ROOM_DETAIL_URL = "/lab/rest/room/detail";
export const ROOM_ARRANGE_URL = "/lab/rest/reservations/arrangement";
export const ROOM_RESERVE_URL = "/lab/rest/reservations/reserve";
export const MY_ROOM_RESERVE_URL = "/lab/rest/reservations/my";
export const RSET_TOKEN_URL = "/lab/rest/tokens";
export const WECHAT_TOKEN_URL = "/wechat/authorization"
export const SEARCH_ARRANGEMENT_URL = "/lab/rest/reservations/searchArrangement"
export const CHECK_TOKEN_URL = "/lab/rest/tokens/checkToken"
export const DELETE_ROOM_URL = "/lab/rest/room/delete"
export const SAVE_ROOM_URL = "/lab/rest/room/save"
export const CANCEL_RESERVE_URL = "/lab/rest/reservations/cancel"
export const GET_TOKEN_BYKEY_URL = "/lab/rest/tokens/getTmpToken"


export const LOGIN_SUCCESS = "login_success";
export const LOGIN_ERROR = "login_error";
